import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { EditableAvatar } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/MultiUser/EditableAvatar";
import { getTeamMemberProfileImages } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/MultiUser/utils";
import { ValueProps } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/MultiUser/ValueProps";
import { ProfilePictureUploadModal } from "@faire/retailer-visitor-shared/components/Modals/ProfilePictureUploadModal/ProfilePictureUploadModal";
import { TeamMembersModal } from "@faire/retailer-visitor-shared/components/Modals/TeamMembersModal/TeamMembersModal";
import { TeamMemberUserInfo } from "@faire/retailer-visitor-shared/components/TeamMemberUserInfo";
import { useRecordMilestoneByDay } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { trackUpmarketMultiUserEducationBannerEditableAvatarClick } from "@faire/web-api--source/events/upmarket/click/multiUserEducationBannerEditableAvatar";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER_SEEN";
import compact from "lodash/compact";
import React from "react";
import styled from "styled-components";
export var MultiUserTeamPermissionEducationBanner = function() {
    var _layoutElement_layout_element_data, _layoutElement_layout_element_data1;
    var layoutElement = React.useContext(Context).layoutElement;
    var _React_useState = _sliced_to_array(React.useState(false), 2), showProfilePicUploadModal = _React_useState[0], setShowProfilePicUploadModal = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), showTeamMembersModal = _React_useState1[0], setShowTeamMembersModal = _React_useState1[1];
    var isMobile = useViewport().isMobile;
    var simpleImageTitles = compact(layoutElement === null || layoutElement === void 0 ? void 0 : (_layoutElement_layout_element_data = layoutElement.layout_element_data) === null || _layoutElement_layout_element_data === void 0 ? void 0 : _layoutElement_layout_element_data.map(function(layoutElementData) {
        return layoutElementData.simple_image_title;
    }));
    var additionalTeamMembersData = simpleImageTitles.filter(function(simpleImageTitle) {
        return !(simpleImageTitle === null || simpleImageTitle === void 0 ? void 0 : simpleImageTitle.image) && !(simpleImageTitle === null || simpleImageTitle === void 0 ? void 0 : simpleImageTitle.images.length);
    })[0];
    var teamMemberUsersData = simpleImageTitles.filter(function(simpleImageTitle) {
        return (simpleImageTitle === null || simpleImageTitle === void 0 ? void 0 : simpleImageTitle.image) || (simpleImageTitle === null || simpleImageTitle === void 0 ? void 0 : simpleImageTitle.images.length);
    });
    var valueProps = compact(layoutElement === null || layoutElement === void 0 ? void 0 : (_layoutElement_layout_element_data1 = layoutElement.layout_element_data) === null || _layoutElement_layout_element_data1 === void 0 ? void 0 : _layoutElement_layout_element_data1.map(function(layoutElementData) {
        return layoutElementData.grid_tile;
    }));
    var _useUserStore = useUserStore([
        "user",
        "firstName",
        "lastName"
    ]), user = _useUserStore.user, firstName = _useUserStore.firstName, lastName = _useUserStore.lastName;
    var userName = firstName + " " + lastName;
    var recordMilestoneByDay = useRecordMilestoneByDay();
    var ref = useDoActionWhenVisible(function() {
        recordMilestoneByDay(RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER_SEEN);
    });
    var handleUserAvatarClick = function() {
        trackUpmarketMultiUserEducationBannerEditableAvatarClick();
        setShowProfilePicUploadModal(true);
    };
    var handleUploadProfileImageModalClose = function() {
        setShowProfilePicUploadModal(false);
    };
    var userToken = useUserStore([
        "userToken"
    ]).userToken;
    var _layoutElement_background_color;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showProfilePicUploadModal ? /*#__PURE__*/ _jsx(ProfilePictureUploadModal, {
                onClose: handleUploadProfileImageModalClose
            }) : null,
            showTeamMembersModal ? /*#__PURE__*/ _jsx(TeamMembersModal, {
                onClose: function() {
                    return setShowTeamMembersModal(false);
                }
            }) : null,
            /*#__PURE__*/ _jsx(Container, {
                $backgroundColor: (_layoutElement_background_color = layoutElement.background_color) !== null && _layoutElement_background_color !== void 0 ? _layoutElement_background_color : Decorative.tint.yellow,
                ref: ref,
                children: /*#__PURE__*/ _jsxs(Wrapper, {
                    children: [
                        /*#__PURE__*/ _jsxs(Content, {
                            children: [
                                /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                                    mobile: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsxs(TeamMemberUserInfoRowMobile, {
                                                "data-test-id": "mobile-team-members-row",
                                                onClick: function() {
                                                    return setShowTeamMembersModal(true);
                                                },
                                                children: [
                                                    teamMemberUsersData.flatMap(getTeamMemberProfileImages).map(function(image, index) {
                                                        var _image_url;
                                                        return /*#__PURE__*/ _jsx(AvatarWrapper, {
                                                            "data-test-id": "homepage-team-member-avatar-".concat(index),
                                                            children: /*#__PURE__*/ _jsx(TeamMemberAvatar, {
                                                                size: "x-small",
                                                                image: IImage.build({
                                                                    url: (_image_url = image.url) !== null && _image_url !== void 0 ? _image_url : ""
                                                                })
                                                            })
                                                        }, index);
                                                    }),
                                                    additionalTeamMembersData ? /*#__PURE__*/ _jsx(AdditionalTeamMemberInfo, {
                                                        children: /*#__PURE__*/ _jsx(Typography, {
                                                            variant: "labelSansRegular",
                                                            color: Core.text.inverse,
                                                            children: additionalTeamMembersData.main_text
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                height: "1x"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: isMobile ? "pageHeaderSerifRegular" : "displayMSerifRegular",
                                    children: layoutElement.main_text
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "1x"
                                }),
                                /*#__PURE__*/ _jsx(ValueProps, {
                                    valueProps: valueProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Content, {
                            children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                                tabletAndAbove: /*#__PURE__*/ _jsx(TeamMemberUserInfoRow, {
                                    children: _to_consumable_array(teamMemberUsersData).reverse().map(function(teamMemberUserData, index) {
                                        var _teamMemberUserData_main_text;
                                        return userToken === teamMemberUserData.token ? /*#__PURE__*/ _jsx(EditableAvatar, {
                                            name: userName,
                                            onClick: handleUserAvatarClick,
                                            image: user === null || user === void 0 ? void 0 : user.profile_image
                                        }, index) : /*#__PURE__*/ _jsx(StyledTeamMemberUserInfo, {
                                            images: getTeamMemberProfileImages(teamMemberUserData),
                                            subtitle: (_teamMemberUserData_main_text = teamMemberUserData.main_text) !== null && _teamMemberUserData_main_text !== void 0 ? _teamMemberUserData_main_text : "",
                                            size: "x-large",
                                            maxTextWidth: 140,
                                            spacingAboveTitle: "3x",
                                            avatarPileOffset: 80,
                                            onClick: function() {
                                                return setShowTeamMembersModal(true);
                                            }
                                        }, index);
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var Container = styled.div.withConfig({
    componentId: "sc-21337408-0"
})([
    "background-color:",
    ";"
], function(param) {
    var $backgroundColor = param.$backgroundColor;
    return $backgroundColor;
});
var Wrapper = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-21337408-1"
})([
    "max-width:1280px;margin:auto;"
]);
var TeamMemberUserInfoRow = styled(Row).withConfig({
    componentId: "sc-21337408-2"
})([
    "width:fit-content;align-self:center;"
]);
var TeamMemberUserInfoRowMobile = styled(Row).withConfig({
    componentId: "sc-21337408-3"
})([
    "width:fit-content;align-self:baseline;&:hover{cursor:pointer;}"
]);
var AvatarWrapper = styled.div.withConfig({
    componentId: "sc-21337408-4"
})([
    "margin-left:-8px;&:first-child{margin-left:0;}"
]);
var StyledTeamMemberUserInfo = styled(TeamMemberUserInfo).withConfig({
    componentId: "sc-21337408-5"
})([
    "padding-left:",
    ";padding-right:",
    ";"
], getSpacing("2x"), getSpacing("2x"));
var Content = styled(Column).withConfig({
    componentId: "sc-21337408-6"
})([
    "padding:",
    ";",
    "{padding:",
    ";width:50%;}"
], getSpacing("4x", "3x"), responsiveMediaQueries.tabletAndAbove, getSpacing("6x", "7x"));
var TeamMemberAvatar = styled(Avatar).withConfig({
    componentId: "sc-21337408-7"
})([
    "border:1px solid ",
    ";"
], Core.surface.subdued);
var AdditionalTeamMemberInfo = styled(Column).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-21337408-8"
})([
    "border:1px solid ",
    ";background-color:",
    ";border-radius:50%;width:32px;height:32px;margin-left:-8px;z-index:2;"
], Core.surface.subdued, Core.surface.default);
